import React from 'react';
import LoginOverlay from './Authorization/LoginOverlay';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error
    console.error('Error caught by boundary:', error, errorInfo);
    
    // If it's an authentication error, clear auth data
    if (error.message?.includes('Authentication failed') || 
        error.message?.includes('Token validation failed')) {
      localStorage.clear();
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          flexDirection: 'column'
        }}>
          <h2>Something went wrong.</h2>
          <p>Please try logging in again.</p>
          <LoginOverlay />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 